import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { useSelector } from "react-redux";

import { store } from "@components/VerticalLayout/store";

import { RootState } from "../../../../../redux/store";

import "../index.css";

import { FidelityAuresKonnectProps } from "./types";
import { useSaleModeToggle } from "./useSaleModeToggle";

import GroupInput from "./sections/GroupInput";
import LabeledSwitch from "./sections/LabeledSwitch";
import FidelityPointsInput from "./sections/FidelityPointsInput";
import MoneyCorrespondenceInput from "./sections/MoneyCorrespondenceInput";
import SaleModeList from "./sections/SaleModeList";

export default function FidelityAuresKonnectWrapper(
    props: FidelityAuresKonnectProps
) {
    const {
        numberFidelityPoints,
        setNumberFidelityPoints,
        moneyCorrespondence,
        setMoneyCorrespondence,
        sortedVisibility,
        setSortedVisibility,
        setIsEdited,
        dataFidelity,
        auresKonnectGroup,
        setAuresKonnectGroup,
        inputGroup,
        setInputGroup,
        isCentralizationActive,
        setIsCentralizationActive,
        isVisibiliteActive,
        setIsVisibiliteActive,
        choiceFidelity,
        isExist = false,
        isFidelityNumberInValid,
        inputNumberFidelityPoints,
        setInputNumberFidelityPoints,
        isTest,
        isConsult,
    } = props;

    const { t } = useTranslation();
    const { oneShop } = useSnapshot(store);
    const isConsultModalOpened = useSelector(
        (s: RootState) => s.fidelity.isConsultModalOpened
    );

    const isFieldDisabled =
        (oneShop && dataFidelity?.Id !== undefined) ||
        isTest ||
        isConsultModalOpened;

    const onSaleModeToggle = useSaleModeToggle(
        sortedVisibility,
        setSortedVisibility,
        t
    );

    const toggleCentralization = () => {
        setIsCentralizationActive(!isCentralizationActive);
        setIsEdited(true);
    };

    const toggleVisibility = () => {
        setIsVisibiliteActive(!isVisibiliteActive);
        setIsEdited(true);
    };

    return (
        <React.Fragment>
            <GroupInput
                auresKonnectGroup={auresKonnectGroup}
                setAuresKonnectGroup={setAuresKonnectGroup}
                setInputGroup={setInputGroup}
                setIsEdited={setIsEdited}
                inputGroup={inputGroup}
                isExist={isExist}
                choiceFidelity={choiceFidelity}
                dataFidelity={dataFidelity}
                isTest={isTest}
                isCentralizationActive={isCentralizationActive}
                isConsultModalOpened={isConsultModalOpened}
                isConsult={isConsult}
                t={t}
            />

            <LabeledSwitch
                label={t("Enable Loyalty Centralization")}
                tooltipText={t(
                    "The centralisation of loyalty makes it possible to group customer data, thus offering them the possibility to use their balance of loyalty points in all franchise stores"
                )}
                showTooltip={!(isCentralizationActive && isConsultModalOpened)}
                checked={isCentralizationActive}
                onChange={toggleCentralization}
                switchClassName="fed_icn_loyaltyCentralization fdl_icn_enableLoyaltyCentralization"
                isFieldDisabled={isFieldDisabled}
                isConsult={isConsult}
            />

            <FidelityPointsInput
                numberFidelityPoints={numberFidelityPoints}
                setNumberFidelityPoints={setNumberFidelityPoints}
                setInputNumberFidelityPoints={setInputNumberFidelityPoints}
                setIsEdited={setIsEdited}
                isFidelityNumberInValid={isFidelityNumberInValid}
                inputNumberFidelityPoints={inputNumberFidelityPoints}
                isFieldDisabled={isFieldDisabled}
                isCentralizationActive={isCentralizationActive}
                isConsultModalOpened={isConsultModalOpened}
                isConsult={isConsult}
                t={t}
            />

            <MoneyCorrespondenceInput
                moneyCorrespondence={moneyCorrespondence}
                setMoneyCorrespondence={setMoneyCorrespondence}
                setIsEdited={setIsEdited}
                isConsult={isConsult}
                t={t}
            />

            <LabeledSwitch
                label={t("Visibility")}
                tooltipText={t(
                    "Attention! If you want to manage loyalty by sales mode, please ensure that the authentication step in the kiosk journey is placed strictly after the sales mode selection."
                )}
                showTooltip={!(isCentralizationActive && isConsultModalOpened)}
                checked={isVisibiliteActive}
                onChange={toggleVisibility}
                switchClassName="fed_icn_loyaltyCentralization fdl_icn_visibilite"
                isFieldDisabled={isFieldDisabled}
                isConsult={isConsult}
            />

            <SaleModeList
                sortedVisibility={sortedVisibility}
                onToggle={onSaleModeToggle}
                setIsEdited={setIsEdited}
                isFieldDisabled={isFieldDisabled}
                isCentralizationActive={isCentralizationActive}
                isConsultModalOpened={isConsultModalOpened}
                isConsult={isConsult}
            />
        </React.Fragment>
    );
}
